export default __webpack_public_path__ + "static/veloxball-ccd9b13a68b83f3c829eea4817f033f3.png";